<template>
  <div class="main">
    <ol>
      <li>Sign in to the OTHER account on home bank</li>
      <li>Go to the Transfer Page</li>
      <li>Click the PINS button</li>
      <li>Enter a phone number currently on that account and click 'Request Pin'</li>
      <li>Enter the 6-Digit Validation PIN that gets sent to that phone</li>
      <li>Setup a 4-Digit PIN for Visible Balance and/or Hidden Balance</li>
      <li>Optionally Check the 'One-Time-Only' box</li>
      <li>Click the 'Save Pins' button</li>
      <li>Now sign into the Source Account and click on 'OTHER' to transfer money
        to that destination Account (using one of the PINS that was just setup)</li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'pinSetupHelp',
};
</script>

<style scoped>
.main {
  font-size: 12px;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/pinSetupHelp.vue